import { PaymentMethod } from "../payment/payment";

export type OrgPaymentSetting = {
  orgId: string;
  sbpsMerchantId: string;
  sbpsServiceId: string;
  availablePaymentMethods: PaymentMethod[];
  tdsAvailableAt: Date | null;
};

// 第2引数 flg の意味
// 全てのテナントが3-Dセキュア決済を利用する訳ではなく、社内運用としてはクレカ決済、3-Dセキュア決済どちらも動作確認できる方が望ましい
// * fe-portal:
//   staticFeatureFlag_EnableTDS メソッドが渡される
//   特定の手続き名のみを対象に3-Dセキュア決済を有効にする
// * fe-dashboard:
//   特に制御するべき箇所がないので一律trueが渡される
export const availableTDS = (
  orgPaymentSetting: OrgPaymentSetting | undefined,
  flg: boolean,
): boolean => {
  if (!flg) return false;
  if (!orgPaymentSetting?.tdsAvailableAt) return false;

  const now = new Date();
  const availableAt = new Date(orgPaymentSetting.tdsAvailableAt);

  return now >= availableAt;
};
